export const DOCUMENT_TYPES = {
  ACCOUNT_APPROVAL_LETTER: "account_approval_letter",
  ADDRESS_VERIFICATION: "address_verification",
  CIP_RESULT: "cip_result",
  COMPANY_FORMATION: "company_formation",
  DATE_OF_BIRTH_VERIFICATION: "date_of_birth_verification",
  ENTITY_OPERATING_DOCUMENT: "entity_operating_document",
  ENTITY_REGISTRATION: "entity_registration",
  HIO_DECLARATION_FORM: "hio_declaration_form",
  IDENTITY_VERIFICATION: "identity_verification",
  LIMITED_TRADING_AUTHORIZATION: "limited_trading_authorization",
  PEP_DECLARATION_FORM: "pep_declaration_form",
  TAX_ID_VERIFICATION: "tax_id_verification",
  W8BEN: "w8ben",
  W9: "w9",
  ADDITIONAL_DOCUMENT: "additional_document", // Keeping this as it's used in logic but not in image
};

export const MAX_SIZE = 10 * 1024 * 1024; // 10MB
export const ALLOWED_ALL_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf",
];
export const DOCUMENT_CONFIG = {
  [DOCUMENT_TYPES.IDENTITY_VERIFICATION]: {
    id: DOCUMENT_TYPES.IDENTITY_VERIFICATION,
    title: "Verify your identity",
    description:
      "Upload a government issued ID and any supporting documents, make sure your document:",
    requirements: [
      "Contains your legal name, issue date, and full address.",
      "Isn't a screenshot.",
    ],
    allowedFileTypes: ALLOWED_ALL_TYPES,
  },
  [DOCUMENT_TYPES.ADDRESS_VERIFICATION]: {
    id: DOCUMENT_TYPES.ADDRESS_VERIFICATION,
    title: "Verify your address",
    description:
      "Upload a utility bill or bank statement to verify your address.",
    requirements: [
      "Must be dated within the last 3 months.",
      "Must clearly show your name and address.",
      "Isn't a screenshot.",
    ],
    allowedFileTypes: ALLOWED_ALL_TYPES,
  },
  [DOCUMENT_TYPES.TAX_ID_VERIFICATION]: {
    id: DOCUMENT_TYPES.TAX_ID_VERIFICATION,
    title: "Verify Tax ID",
    description: "Upload a document verifying your Tax ID.",
    requirements: ["Official tax document.", "Shows full name and Tax ID."],
    allowedFileTypes: ALLOWED_ALL_TYPES,
  },
  [DOCUMENT_TYPES.ACCOUNT_APPROVAL_LETTER]: {
    id: DOCUMENT_TYPES.ACCOUNT_APPROVAL_LETTER,
    title: "Compliance Approval Letter",
    description:
      "Upload a letter signed by your compliance officer granting permission to carry the account.",
    requirements: [
      "Must be on company letterhead.",
      "Signed by compliance officer.",
      "Must be a PDF.",
    ],
    allowedFileTypes: ["application/pdf"],
  },
  [DOCUMENT_TYPES.COMPANY_FORMATION]: {
    id: DOCUMENT_TYPES.COMPANY_FORMATION,
    title: "Company Information",
    description:
      "Upload a document with company name, address, compliance email, and ticker symbol.",
    requirements: ["Must be a PDF.", "Includes compliance contact info."],
    allowedFileTypes: ["application/pdf"],
  },
  [DOCUMENT_TYPES.ADDITIONAL_DOCUMENT]: {
    id: DOCUMENT_TYPES.ADDITIONAL_DOCUMENT,
    title: "Additional Verification",
    description: "Upload any additional requested documents.",
    requirements: ["Clear and legible.", "Matches requested information."],
  },
};

export const MODAL_STATUS = {
  UPLOAD: "upload",
  PROCESSING: "processing",
  ERROR: "error",
  SUCCESS: "success",
  SUCCESS_PROCESSING: "success_processing",
};
